<template>
	<div id="top" class="container" :class="{ index: route.name.startsWith('index') }">
		<Html :lang="locale" />
		<Head v-if="page">
			<Title>{{ page.metaTitle }}</Title>
			<Meta name="description" :content="page.metaDescription" />
			<Meta name="robots" :content="page.metaRobots" />
			<Hreflangs v-if="page.slug !== '404'" :langmenu="page.langmenu" />
		</Head>

		<navigation :class="page && page.headingImage ? '' : 'no-slider'" :contentblocks="page.contentblocks" />

		<client-only>
			<component :is="'script'">
				(function (d, s, id) { const el = d.getElementsByTagName(s)[0]; if (d.getElementById(id) ||
				el.parentNode == null) { return; } var js = d.createElement(s); js.id = id; js.async = true; js.src =
				'https://sdk.zenchef.com/v1/sdk.min.js'; el.parentNode.insertBefore(js, el); })(document, 'script',
				'zenchef-sdk');
			</component>

			<div class="zc-widget-config" data-restaurant="382267" :data-lang="locale" data-open="2000"></div>
		</client-only>

		<slot />

		<footers :contentblocks="page.contentblocks" />

		<cookie-consent v-if="defaults[locale].cookieConsent.published" :item="defaults[locale].cookieConsent" />
		<to-top />
	</div>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();
const config = useRuntimeConfig();
const route = useRoute();
const { defaults, fetchDefaults } = useDefaults();

await fetchDefaults();
await fetchPage();

const currentUrl = config.public.siteUrl + route.fullPath;
const { website } = defaults.value[locale.value];
const { metaDescription, metaTitle } = page.value;

if (import.meta.server) {
	useSeoMeta({
		twitterCard: metaDescription || '',
		twitterSite: currentUrl || '',
		twitterTitle: metaTitle || '',
		twitterDescription: metaDescription || '',
		twitterCreator: website.hotelName || '',
		twitterImage: website.structuredImage || '',
		ogTitle: metaTitle || '',
		ogUrl: currentUrl || '',
		ogImage: website.structuredImage || '',
		ogDescription: metaDescription || '',
		ogSiteName: website.hotelName || '',
	});

	useHead({
		script: [
			{
				type: 'application/ld+json',
				innerHTML: JSON.stringify({
					'@context': 'http://schema.org',
					'@graph': [
						{
							'@type': 'Restaurant',
							'@id': `${config.public.siteUrl}#restaurant`,
							image: website.structuredImage,
							url: config.public.siteUrl,
							name: website.hotelName,
							logo: `${config.public.siteUrl}/images/logo-bistrofrancis-hero.svg`,
							telephone: website.phone,
							email: website.email,
							address: {
								'@type': 'PostalAddress',
								streetAddress: `${website.street} ${website.number}, ${website.city}`,
								postalCode: website.postalCode,
							},
						},
					],
				}),
			},
		],
	});
}
</script>
